import React, { useState } from 'react';

const FAQItem = ({ question, answer, className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={`bg-white/80 backdrop-blur-sm rounded-xl border border-white/20 p-6 hover:shadow-lg transition-all duration-300 ${className}`}>
      <button
        className="w-full text-left focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-lg"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900 pr-4">
            {question}
          </h3>
          <svg
            className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </button>
      
      {isOpen && (
        <div className="mt-4 animate-fadeIn">
          <p className="text-gray-600 leading-relaxed">{answer}</p>
        </div>
      )}
    </div>
  );
};

export default FAQItem;